module.exports = __webpack_public_path__ + "static/media/bottomsheet_verify_mobile.82876bf4.svg";